var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.is_stopped_on_text_reply === true)?_c('span',[_vm._v("Yes")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }